import "core-js/modules/web.dom.iterable";
import overArg from './_overArg.js';
/* Built-in method references for those with the same name as other `lodash` methods. */

var nativeKeys = overArg(Object.keys, Object);
export default nativeKeys;